import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import IconButton from "@mui/material/IconButton";

function Input(props) {
  const [format, setFormat] = useState("");
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");

  const [showPassword, setShowPassword] = React.useState(false);

  const [isValid, setIsValid] = useState({ showErr: false, isErr: false });
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const onChange = (e) => {
    // console.log('value', e)
    // console.log("length in input", value2, props.value, e.target.value);
    // console.log("length in input 2", e.target.value);

    if (props.type === "file") {
      props.onChange(e.target.files[0]);
    }
    // else if(props.id === "password"){
    //   if (props.value.length < e.target.value.length) {
    //     props.onChange(e.target.value);

    //     // props.onChange(props.value + e.target.value[e.target.value.length - 1]);
    //   } else if (props.value.length > 0) {
    //       // return str;
    //       props.onChange(props.value);

    //       // props.onChange(props.value.slice(0, -1));

    //   }else{
    //   props.onChange(e.target.value);

    //   }
    // }
    else {
      
      if(props?.placeholder?.includes("Please Enter Email") ||props?.type !== "date" ){
        props.onChange(e.target.value);

      }else{
        props.onChange(e.target.value.replace(/[^a-zA-Z0-9. ]/g, ""));

      }
        
    }

    // setValue(e.target.value);
  };

  const getMaskedPassword = (password) => {
    if (props.mask) {
      if (value2 !== password) {
        setValue2(password);
      }
      if (showPassword) {
        return password;
      } else if (props.id !== "aadhar") {
        if (password.length <= 3) {
          return password;
        } else {
          if (typeof password === "string") {
            return (
              password?.slice(0, 3) +
              "*".repeat(
                password?.length - (password?.length > 6 ? 6 : password?.length)
              ) +
              password?.slice(-3)
            );
          }
        }
      }
    }
  };

  const showInput = (type) => {
    let newValue = props?.value;
    if (type) {
      newValue = "*".repeat(newValue?.length);
    }
    setShowPassword(type);
    // setValue(newValue);
  };
  const maskPan = (pan) => {
    // console.log('in pan', pan)
    // if (pan?.length > 3) {
    //   let first = pan.slice(0, 3);
    //   let newPan = pan.slice(3);
    //   let stars = "*".repeat(newPan.length);
    //   pan = pan.substring(0, 3) + "*".repeat(pan.length - 3);
    //   console.log("slice", pan.substring(0, 3) + "*".repeat(pan.length - 3));
    //   //  pan= pan.substring(0, 3) + "*".repeat(pan.length - 3)
    // }
    return pan;
  };
  useEffect(() => {
    if (
      props.id === "otp" ||
      props.id === "mobile" ||
      props.id === "aadhar" ||
      props.id === "email" ||
      props.id === "panNumber" ||
      props.id === "number" ||
      props.id === "name" ||
      props.id === "pinCode"
    ) {
      let isError = false;
      if (props.id === "panNumber") {
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
        isError = !panRegex.test(value.toUpperCase());
      } else if (props.id === "pinCode") {
        const pinRegex = /^\d{6}$/;
        if (value?.length < 6) {
          isError = true;
          // isError = !pinRegex.test(value);
        }
        // console.log("is pin", isError);
        // } else if (props.id === "mobile") {
        //   const pinRegex = /[0-9]{10,}/;
        //   console.log("id", !pinRegex.test(value));
        //   isError = !pinRegex.test(value);
      } else if (props.id === "email") {
        const pinRegex =
          /^([a-zA-Z0-9._-]+)@([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,4})$/;
        console.log("id", !pinRegex.test(value));
        isError = !pinRegex.test(value);
      } else if (props.id === "otp") {
        const pinRegex = /[0-9]{6}/;
        console.log("id", !pinRegex.test(value));
        isError = !pinRegex.test(value);
        if (value == "000000") {
          isError = true;
        }
      } else if (props.id === "name") {
        const pinRegex = /^[a-zA-Z\s]*$/;
        isError = !pinRegex.test(value);
      } else if (props.id === "number") {
        const pinRegex = /^(\d{1,3}(,\d{3})*(\.\d{2})?)$/;
        // console.log("id", !pinRegex.test(value));
        isError = !pinRegex.test(value);
      }
      if (props.setValid) {
        props.setValid(!isError);
      }
      setIsValid({ ...isValid, isErr: isError });
    }
  }, [value]);

  useEffect(() => {
    if (
      props.id === "otp" ||
      // props.id === "aadhar" ||
      props.id === "email" ||
      // props.id === "panNumber" ||
      // props.id === "number" ||
      // props.id === "name" ||
      props.id === "pinCode"
    ) {
      setIsValid({ ...isValid, showErr: true });
    }
  }, []);
  return (
    <div className="input-div" id={props.id}>
      <div className="input-forms" id={props.id}>
        {props?.inputType === "rupee" ? (
          <div className="rupee-input">
            <FormControl fullWidth sx={{ m: 1 }} variant="standard">
              <InputLabel htmlFor="standard-adornment-amount">
                {props?.inputType === "mobile" ? "+91" : "₹"}
              </InputLabel>
              <TextField
                disabled={props.disabled || false}
                onChange={onChange}
                error={isValid.showErr && isValid.isErr}
                id="outlined-search"
                // id="outlined-disabled"

                label={props.placeholder}
                value={props?.value}
                type={props?.type || "text"}
              />
            </FormControl>
            {/* <InputLabel htmlFor="standard-adornment-amount">Amount</InputLabel>

            <Input
              id="standard-adornment-amount"
              startAdornment={
                <InputAdornment position="start">$</InputAdornment>
              }
            /> */}
          </div>
        ) : (
          <>
            {props.id === "aadhar" || props.id === "password" ? (
              <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                {/* <InputLabel htmlFor="standard-adornment-amount">
                {props.inputType === "mobile" ? "+91" : "₹"}
              </InputLabel> */}
                <InputLabel htmlFor="outlined-adornment-password">
                  {props.placeholder}
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  disabled={props.disabled || false}
                  type={
                    showPassword
                      ? "text"
                      : (props.id === "aadhar" && props.type) || props.type
                  }
                  error={isValid.showErr && isValid.isErr}
                  onChange={(e) => onChange(e)}
                  value={
                    // showPassword ?
                    // getMaskedPassword(props.value)
                    props.value
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => showInput(!showPassword)}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
            ) : (
              <TextField
                checked={props?.checked}
                onChange={onChange}
                disabled={props.disabled || false}
                id="outlined-multiline-static"
                rows={6}
                error={isValid.showErr && isValid.isErr}
                // id="outlined-search"
                label={props.placeholder}
                multiline={props?.multiline}
                min={"1950-01-01"}
                // onKeyDown={(e) => props.type === "date" && e.preventDefault()}
                value={
                  props.id === "panNumber"
                    ? maskPan(props?.value)
                    : props?.value
                }
                type={props.type || "text"}
              />
            )}
          </>
        )}
        {isValid.showErr && isValid.isErr && (
          <p style={{ color: "red" }}>
            Please enter a valid{" "}
            {props.id === "panNumber"
              ? "PAN card number"
              : props.id === "otp"
              ? "OTP"
              : props.id === "aadhar"
              ? "Aadhar card number"
              : props.id === "email"
              ? "Email"
              : props.id === "number"
              ? "Number"
              : props.id === "name"
              ? "Name"
              : props.id === "pinNumber"
              ? "Pin code"
              : ""}
          </p>
        )}
      </div>
    </div>
  );
}

export default Input;
